<template>
    <admin-layout :show-sidebar="false" :mainPage="project ? 'project' : 'learning-path'">

        <template v-if="editable" #toolbox>
            <learning-path-toolbox :learning-path="path_repo" @reload-page="reloadPage"/>
        </template>

        <app-content-pane class="ml-3" :key="path_repo" v-if="path_repo">
            <template #title>

                <heading :project="project"
                         :path="path"
                         :actions="head_actions"
                         :tenants="tenants"
                         @action="headAction"
                         page="path"
                         class="mb-3" />

                <template v-if="!project">
                    <hr class="mb-0">
                    <div v-if="!project" class="actions px-4 py-3">

                        <h5 class="h6 mb-0 mr-auto">
                            This is a learning path template.
                        </h5>

                        <div class="form-group mb-0">
                            <inertia-link v-if="current_user_is_paid"
                                          :href="route('project.create', {path: path.id, ...global_url_params})"
                                          class="btn btn-primary d-flex align-items-center justify-content-center">
                                Use this template
                            </inertia-link>
                        </div>
                    </div>
                </template>

            </template>

            <section v-if="project">
                <div class="bg-dark text-light px-3 py-3 d-flex align-items-center">
                    <p class="mb-0 mr-1">This is the teacher's workspace.</p>
                    <inertia-link
                        :href="route('project.canvas.preview', {project: project.id, ...global_url_params})"
                        class="btn btn-light ml-auto">Preview the student canvas view</inertia-link>
                </div>
            </section>
            <section v-else class="px-4 py-3">
                <div class="row">
                    <div v-for="project in projects" class="col-md-3">
                        <project-card :project="project"
                                      class="mb-4"
                                      :manage-teams="false"
                                      :show-footer="false"
                                      :show-info="false" />
                    </div>
                </div>
            </section>

            <section v-for="(stage, stage_id) in path_repo.fragments.stages" :key="stage_id">
                <fids-section :stage="stage"
                              :path="path_repo"
                              :editable="editable"
                              :is_project="project?true:false"
                              @mission-statement-changed="missionChanged"
                              @resource-changed="resourceChanged"
                              @activity-group-changed="activityGroupChanged"
                              @combined-activities-changed="combinedActivitiesChanged($event)"
                              @activities-changed="activitiesChanged"/>
            </section>

        </app-content-pane>

    </admin-layout>
</template>

<script>
import AdminLayout from "@/Layouts/AdminLayout";
import AppContentPane from "@/Components/AppContentPane";
import LearningPathToolbox from "@/Components/Toolbox/LearningPathToolbox";
import ProjectCard from "@/Components/Project/ProjectCard";
import FidsSection from "@/Components/LearningPath/FidsSection";
import {mapActions} from "vuex";
import API from "@/API";
import Heading from "@/Components/Project/Heading";

export default {
    name: "Edit",
    components: {
        AdminLayout,
        AppContentPane,
        FidsSection,
        Heading,
        LearningPathToolbox,
        ProjectCard
    },

    props: {
        path: {
            type: [Object],
            default: () => null,
        },
        project: {
            type: Object,
            default: () => null,
        },
        tenants: {
            type: Array,
            default: () => [],
        }
    },

    data(){
        return {

            path_repo: null,
            scope: {name: API.fragments.SCOPE_LEARNING_PATH, id: this.path.id},
            projects: [], /*projects.filter(p => p.learning_path.id == this.path )*/

            head_actions: {},

            // settings: null,

            okay: false,

        };
    },


    computed: {
        show_sidebar(){
            return this.$page.props.user.is_admin || this.$page.props.user?.project_count > 0;
        },

        editable(){
            if(this.is_admin) return true;

            let editable_by;
            if(this.project){
                editable_by = this.project.meta.editable_by;
            }else{
                editable_by = this.path.meta.editable_by;
            }

            if(editable_by === this.current_user?.type){
                return true;
            }else{
                return false;
            }
            // return (this.$page.props.user.is_admin || ( this.$page.props.user.is_teacher && this.path.created_by_id === this.$page.props.user.id));
            // return this.has_edit_access && this.head_actions?.edit?.active;
            return this.has_edit_access;
        }
    },


    methods: {
        ...mapActions('repositories', {
            repo: 'getRepository',
            freeRepo: 'freeRepository',
            updateRepo: 'updateRepository',
        }),

        headAction(method, action){
            switch( method ){

                case 'edit':

                    action.active = !action.active;

                    if( action.active ){
                        action.class = 'btn-feel';
                        action.title = 'Finish Editing';
                    }else{
                        action.class = 'btn-outline-feel';
                        action.title = 'Advanced Editing';
                    }

                    break;
                //
                //
                // case 'settings':
                //     this.openSettings();
                //
                //     break;

            }
        },

        // openSettings(){
        //     this.settings = this.path;
        // },
        //
        // closeSettings(){
        //     this.settings = null;
        // },
        //
        // pathDeleted(path){
        //     this.$inertia.visit( route('project.dashboard', {...this.global_url_params}) );
        //     this.closeSettings();
        // },

        missionChanged({stage, missions}){
            const fragments = {};
            fragments[`stage_${stage}_mission_questions`] = missions;
            this.updateRepo({scope: this.scope, fragments});
        },

        resourceChanged({stage, resources}){
            const fragments = {};
            fragments[`stage_${stage}_resources`] = resources;
            this.updateRepo({scope: this.scope, fragments});
        },

        activityGroupChanged({stage, sections}){
            const fragments = {};
            fragments[`stage_${stage}_activity_sections`] = sections;
            this.updateRepo({scope: this.scope, fragments});
        },

        activitiesChanged({stage, section, activities}){
            console.log('Activities Changed.', {stage, section, activities});
            const fragments = {};
            fragments[`stage_${stage}_activities_${section.id}`] = activities;
            this.updateRepo({scope: this.scope, fragments});
        },

        combinedActivitiesChanged({stage, section, activities, shouldReloadPage}){
            const fragments = {};
            console.log( {stage, section, activities} );
            fragments[ `stage_${stage}_combined_activities_${section.id}` ] = activities;
            this.updateRepo({scope: this.scope, fragments});
            console.log("RELOAD?", shouldReloadPage)
            if (shouldReloadPage) {
                this.reloadPage()
            }
        },

        async reloadPage() {
            this.path_repo = null
            await this.$nextTick()
            this.path_repo = (await this.repo(this.scope))
        }

    },

    beforeMount() {

        if( this.has_edit_access ){

            // if( this.is_admin || true ){
            //     this.head_actions['edit'] = {
            //         class: 'btn-outline-feel',
            //         title: 'Advanced Editing',
            //         active: false,
            //     };
            // }
        }
    },

    async mounted() {
        if( this.path ){
            this.path_repo = (await this.repo(this.scope));
        }

        // TODO: Get projects of this learning path if 'project' property is not set.



        if( this.project ){
            this.setTitle( `${this.project.name} - Learning Path` );
        }else{
            this.setTitle( `${this.path.name}` );
        }

    }

}
</script>

<style lang="scss" scoped>
.actions{
    display: flex;
    align-items: center;

    background: $dark;
    color: $light;
}
</style>
